import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private api: ApiService) { }

  getAllProduct(data:any): Observable<any> {
    return this.api.post(environment.getAllProduct,data);
  }

  addProduct(data:any): Observable<any> {
    return this.api.post(environment.addProduct,data);
  }

  updateProduct(data:any): Observable<any> {
    return this.api.post(environment.updateProduct,data);
  }

  deleteProduct(data:any): Observable<any> {
    return this.api.post(environment.deleteProduct,data);
  }

}


